import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { map } from 'rxjs/operators';

import { environment } from '@env';

import { NurseTriage, NurseTriageDTO, NurseTriageViewModelFactory } from '@project/view-models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NursingApiProviderService {
  constructor(private apiService: ApiService) {}

  getNursingTriageAssessment(requisitionId: string): Observable<NurseTriage> {
    return this.apiService
      .get<NurseTriageDTO>(`${environment.environmentVariables.apiCoreUrl}/nursing/${requisitionId}/assessment`)
      .pipe(map(NurseTriageViewModelFactory.createFromDTO));
  }

  postNursingTriageRead(requisitionId: string): Observable<void> {
    return this.apiService.post(
      `${environment.environmentVariables.apiCoreUrl}/nursing/${requisitionId}/assessment/confirm-read`,
    );
  }
}
